import { Controller } from "stimulus";
import Rails from "rails-ujs";


export default class extends Controller {
  static targets = ["input", "uniqNotice"];
  
  connect() {
    
  }

  checkUniqueness() {
    fetch("/shop_discount_codes/check_uniqueness", {
      method: "post",
      credentials: "same-origin",
      headers: {
        'Accept': 'text/vnd.turbo-stream.html',
        "Content-Type": "application/json",
        "X-CSRF-Token": Rails.csrfToken(),
      },
      body: JSON.stringify({ code: this.inputTarget.value }),
    }).then((response) => {   
        if (response.ok) {
          this.uniqNoticeTarget.classList.remove("invisible");
        } else {
          this.uniqNoticeTarget.classList.add("invisible");
        }
    });
     
  }

  appendRandomCode(e) {
    e.preventDefault()
    var randomCode = (Math.random() + 1).toString(36).substring(7).toUpperCase();
    var rootVal = this.inputTarget.value.split("-")[0]
    this.inputTarget.value = this.inputTarget.value.length > 0 ? rootVal + "-" + randomCode : randomCode;
  }

}
